import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import Header from '@buncha/components/composites/Header/Header';
import {Modules} from '@buncha/utils/types';
import NoDataFound from '../noDataFound/NoDataFound';
import React from 'react';
import {useGetLocale} from '@buncha/localization/hooks';

const OrientationWarning: React.FC = () => {
  const {title} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};
  return (
    <Header showDefaultLeftHeader={false} hideBottomSafeArea hideUploadFile>
      <NoDataFound title={title?.portraitWarningText} />
    </Header>
  );
};

export default React.memo(OrientationWarning);
